import { render } from "./comments-pinboard-teaser.html?vue&type=template&id=4875df1f"
import script from "./CommentsPinboardTeaser.vue?vue&type=script&lang=ts"
export * from "./CommentsPinboardTeaser.vue?vue&type=script&lang=ts"

import "./comments-pinboard-teaser.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script